var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RideIndex',{attrs:{"fst-id":("franchise-rides_" + _vm.getId),"pageTitle":_vm.title,"qso":_vm.getEndpointOptions,"endpoint":_vm.getEndpoint,"filterItems":_vm.filterOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }